<template>
  <SectionContentNumberedGuideCard v-bind="props" />
</template>

<script setup>
const props = defineProps({
  number: {
    type: String,
    default: '03'
  },
  eyebrow: {
    type: String,
    default: 'Lastly'
  },
  title: {
    type: String,
    default: 'Foster a Positive Mindset'
  },
  theme: {
    type: String,
    default: 'gold'
  },
  introContent: {
    type: String,
    default: ''
  },
  splitCards: {
    type: Array,
    default: () => []
  },
  outroContent: {
    type: String,
    default: ''
  },
  quoteContent: {
    type: String,
    default: ''
  },
  sideContent: {
    type: String,
    default: `<p>Mindset is one of the most underrated and underutilized tools we have when it comes to supporting health and wellness.</p>
<p>A positive outlook/mindset <u>alone</u> is proven to:</p>
<ul>
  <li>Reduce stress levels</li>
  <li>Boost immunity</li>
  <li>Aid in weight management</li>
  <li>Improve cardiovascular health</li>
  <li>Improve sexual health (linked to lower stress levels)</li>
  <li>Boost cognitive health<sup>30</sup></li>
</ul>`
  },
  imageSrc: {
    type: String,
    default: '/assets/images/guide-positive-mindset.jpg'
  },
  imageAlt: {
    type: String,
    default: 'Smiling man pointing upward outdoors'
  },
  tipsTitle: {
    type: String,
    default: 'So then, how can you foster such a mindset?'
  },
  tipsContent: {
    type: String,
    default: `<p>→ Find something to be grateful for each and every day. In other words, practice daily gratitude.</p>
<p>→ Keep a positive outlook, especially during trying circumstances.</p>
<p>→ Surround yourself with likeminded, positive people.</p>
<p>→ Practice positive self-talk, or incorporate daily affirmations.</p>
<p>→ Focus on your strengths, see weaknesses as areas for growth.</p>
<p>→ Smile…often!</p>`
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  },
  paddingBottom: {
    type: String,
    default: 'reduced'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Guide Positive Mindset',
  inputs: [
    {
      name: 'number',
      type: 'text',
      defaultValue: '03'
    },
    {
      name: 'eyebrow',
      type: 'text',
      defaultValue: 'Lastly'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Foster a Positive Mindset'
    },
    {
      name: 'theme',
      type: 'text',
      enum: ['green', 'brown', 'gold'],
      defaultValue: 'gold'
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'splitCards',
      type: 'list',
      defaultValue: [],
      subFields: [
        {
          name: 'value',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'text',
          type: 'longText',
          defaultValue: ''
        },
        {
          name: 'variant',
          type: 'text',
          enum: ['green', 'neutral'],
          defaultValue: 'green'
        }
      ]
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'quoteContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'sideContent',
      type: 'richText',
      defaultValue: `<p>Mindset is one of the most underrated and underutilized tools we have when it comes to supporting health and wellness.</p>
<p>A positive outlook/mindset <u>alone</u> is proven to:</p>
<ul>
  <li>Reduce stress levels</li>
  <li>Boost immunity</li>
  <li>Aid in weight management</li>
  <li>Improve cardiovascular health</li>
  <li>Improve sexual health (linked to lower stress levels)</li>
  <li>Boost cognitive health<sup>30</sup></li>
</ul>`
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/guide-positive-mindset.jpg'
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: 'Smiling man pointing upward outdoors'
    },
    {
      name: 'tipsTitle',
      type: 'text',
      defaultValue: 'So then, how can you foster such a mindset?'
    },
    {
      name: 'tipsContent',
      type: 'richText',
      defaultValue: `<p>→ Find something to be grateful for each and every day. In other words, practice daily gratitude.</p>
<p>→ Keep a positive outlook, especially during trying circumstances.</p>
<p>→ Surround yourself with likeminded, positive people.</p>
<p>→ Practice positive self-talk, or incorporate daily affirmations.</p>
<p>→ Focus on your strengths, see weaknesses as areas for growth.</p>
<p>→ Smile…often!</p>`
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
